import type { ManualCounterpartyRequest, PendingCounterpartySummary } from '@swiftpay/shared';
import { apiFetch } from './client.js';

export const manualCounterpartiesApi = {
  create: (body: ManualCounterpartyRequest) =>
    apiFetch<{ id: string }>('/api/counterparties/manual', { method: 'POST', body: JSON.stringify(body) }),
  listPending: () =>
    apiFetch<PendingCounterpartySummary[]>('/api/counterparties/manual?status=pending'),
  approve: (id: string) =>
    apiFetch<{ ok: true; legalEntityId: string; alreadyApproved: boolean }>(`/api/counterparties/manual/${id}/approve`, { method: 'POST' }),
  reject: (id: string) =>
    apiFetch<{ ok: true }>(`/api/counterparties/manual/${id}/reject`, { method: 'POST' }),
};
